import { IPlayerState } from '../../State/Player/IPlayerState';
import IPlayerData from '../IPlayerData';

export default abstract class PlayerProperty<
    T,
    U extends Partial<IPlayerData>
> {
    /**
     * The default value to be used if no data is found when restoring from an endpoint.
     */
    public abstract readonly defaultValue: T;

    /**
     * Extracts the property value from the player state and returns a number
     * or string to be saved to an endpoint.
     * @param playerStateData
     */
    public abstract save(playerStateData: IPlayerState): U;

    /**
     * Parse the player endpoint data and return the data in a format to be persisted in the player state.
     * @param playerEndpointData
     */
    public abstract restore(playerEndpointData: IPlayerData): T;

    /**
     * Check if the data from the state is different then the currently persisted endpoint data.
     * @param playerStateData
     * @param playerEndpointData
     */
    public abstract isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean;
}
